module.exports = __webpack_public_path__ + "img/sche_7.aaf0b6cb.png";